import { render, staticRenderFns } from "./MarketingSetting.vue?vue&type=template&id=dc5d00a0&scoped=true"
import script from "./MarketingSetting.vue?vue&type=script&lang=js"
export * from "./MarketingSetting.vue?vue&type=script&lang=js"
import style0 from "./MarketingSetting.vue?vue&type=style&index=0&id=dc5d00a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d00a0",
  null
  
)

export default component.exports